import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const auditControllerReducer = (state: RootState) => state.private.auditController;

export const auditActionsSelector = createSelector(auditControllerReducer, (audit) => audit.auditActions);

export const auditFiltersUsedSeletor = createSelector(auditControllerReducer, (audit) => audit.auditFiltersUsed);
